// extracted by mini-css-extract-plugin
export default {"AuthAlert":"PanierAuth_AuthAlert__5hxe+","Title":"PanierAuth_Title__AYdkJ","Description":"PanierAuth_Description__gWqyp"};